import { Table, TableWrapper, Tbody, Td, Th, Thead, Tr } from '@components/core-ui/Table';
import Share from '@components/icons/ShareIcon.svg';
import { getAmericanTime } from '@helpers/getAmericanTimezone';
import { usePageContext } from '@pages/User/NewJobPage/providers/PageProvider';
import { useModalContext } from '@providers/ModalProvider';
import { JobResponseAttorneyAccessDto } from 'app/API';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import toast from 'react-hot-toast';
import { StyledBlock } from './styles/StyledBlock';

export const AttorneysBlock = () => {
  const { openModal } = useModalContext();
  const { form, job, setJob } = usePageContext();

  const description = <p></p>;

  const attorneys = job?.attorneyAccesses ?? [];

  const invite = () => {
    openModal(ModalNamesEnum.AddNewAttorneysAccess, {
      id: job?.id,
      wsid: job?.workspaceId,
      recordingSessionId: form.item?.meetingId,
      onSuccess: (data: JobResponseAttorneyAccessDto) => {
        if (!job) {
          return;
        }
        setJob({
          ...job,
          attorneyAccesses: [...attorneys, data],
        });
      },
    });
  };

  const onCopyButtonClick = (text: string) => {
    toast.success('The link has been copied to the clipboard', {
      duration: 2000,
    });
    navigator.clipboard.writeText(text);
  };

  return (
    <StyledBlock title="Attorney Accesses" description={description}>
      <TableWrapper>
        <Table>
          <Thead>
            <Tr>
              <Th>Email</Th>
              <Th>Passcode</Th>
              <Th>Created</Th>
            </Tr>
          </Thead>
          <Tbody>
            {attorneys.map((data, index) => (
              <Tr key={data.id ?? index}>
                <Td>
                  <p className="mt-3 mb-3">{data?.email}</p>
                </Td>
                <Td>
                  <p className="mt-3 mb-3 flex gap-2 items-center">
                    {data?.passcode && data.url ? (
                      <>
                        {data.passcode.toUpperCase()}
                        <Share
                          className="cursor-pointer hover:text-[var(--color-title)] text-[var(--color-text-muted)] fill-current"
                          onClick={() => onCopyButtonClick(data.url)}
                        />
                      </>
                    ) : (
                      'No passcode'
                    )}
                  </p>
                </Td>
                <Td>
                  <p className="mt-3 mb-3">{getAmericanTime(data.createdAt ?? 0)}</p>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableWrapper>
      <div>
        <button className="invite" type="button" onClick={() => invite()}>
          + Invite Attorney
        </button>
      </div>
    </StyledBlock>
  );
};
